import styled, { css } from 'styled-components';
// styled-components.
// -----------------------------------------------------------------------------
const BaseStyles = ({ align }) => {
    if (align === 'left')
        return css `
      text-align: left;
    `;
    if (align === 'center')
        return css `
      text-align: center;
    `;
    if (align === 'right')
        return css `
      text-align: right;
    `;
};
export const TableCellRoot = styled.td `
  ${({ align }) => BaseStyles({ align })}
`;
export const TableHeadCellRoot = styled.th `
  ${({ align }) => BaseStyles({ align })}
`;
//# sourceMappingURL=TableCell.styled.js.map